/** Position title shown in “Competency for the …” table headers. */
export const COMPETENCY_POSITION_TITLES = {
  RN: "Registered Nurse",
  LVN: "Licensed Practical/Vocational Nurse",
  PT: "Physical Therapist",
  PTA: "Physical Therapist Assistant",
  OT: "Occupational Therapist",
  OTA: "Occupational Therapist Assistant",
  ST: "Speech Therapist",
  MSW: "Medical Social Worker",
};

const TITLE_BY_ALIAS = {
  REGISTEREDNURSE: "RN",
  LICENSEDVOCATIONALNURSE: "LVN",
  LICENSEDPRACTICALVOCATIONALNURSE: "LVN",
  LPN: "LVN",
  PHYSICALTHERAPIST: "PT",
  PHYSICALTHERAPISTASSISTANT: "PTA",
  OCCUPATIONALTHERAPIST: "OT",
  OCCUPATIONALTHERAPISTASSISTANT: "OTA",
  SPEECHTHERAPIST: "ST",
  MEDICALSOCIALWORKER: "MSW",
};

export function competencyPositionTitle(role) {
  const raw = String(role || "").trim();
  if (!raw) return "";
  const upper = raw.toUpperCase();
  if (COMPETENCY_POSITION_TITLES[upper]) {
    return COMPETENCY_POSITION_TITLES[upper];
  }
  const compact = upper.replace(/[^A-Z0-9]+/g, "");
  const aliased = TITLE_BY_ALIAS[compact];
  if (aliased) return COMPETENCY_POSITION_TITLES[aliased];
  return raw;
}

export function competencyForPositionLabel(role) {
  const title = competencyPositionTitle(role);
  return title ? `Competency for the ${title}` : "Competency";
}
